import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { NewTrustedService } from "src/app/generated-models/NewTrustedService";
import { ITeamListRecord } from "src/app/npr-request.model";
import { ApiService } from "src/app/services";
import { LoadingScreenService } from "src/app/shared/loading-screen.service";

export interface AddTrustedServiceModalOptions {
  save: (trustedService: NewTrustedService) => Promise<any>;
  adminTeamList: string[];
}

@Component({
  standalone: false,
  templateUrl: "./add-trusted-service.component.html",
  styleUrls: ["../../styles.scss"],
})
export class AddTrustedServiceComponent implements OnInit {
  @Input() options: AddTrustedServiceModalOptions;
  team: ITeamListRecord;
  trustedTeam: ITeamListRecord;
  ownerTeamList: ITeamListRecord[];
  trustedTeamList: ITeamListRecord[];

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApiService,
    private loadingService: LoadingScreenService,
    private notificationService: ToastrService
  ) {
    this.ownerTeamList = [];
    this.trustedTeamList = [];
  }

  async ngOnInit() {
    this.loadingService.setLoading(true);

    this.apiService?.getTeamList().subscribe(
      (response) => {
        const allTeams = response.map(
          (r) =>
            ({
              label: `${r.Name} (${r.Oid})`,
              value: 0,
              ring: r.Ring ? r.Ring : "No Ring",
              oid: r.Oid,
            }) as ITeamListRecord
        );

        const sortByRingThenLabel = (a: ITeamListRecord, b: ITeamListRecord) =>
          a.ring.localeCompare(b.ring) || a.label.localeCompare(b.label);

        this.ownerTeamList = allTeams.filter((team) => this.options.adminTeamList.includes(team.oid)).sort(sortByRingThenLabel);
        this.trustedTeamList = allTeams.slice().sort(sortByRingThenLabel);
        this.loadingService.setLoading(false);
      },
      (e: any) => {
        this.loadingService.setLoading(false);
        this.notificationService.error(e);
      }
    );
  }

  async submit() {
    if (!this.team) {
      this.notificationService.warning(`Please select the service that you own.`);
      return;
    }

    if (!this.trustedTeam) {
      this.notificationService.warning(`Please select the trusted service.`);
      return;
    }

    if (this.team.oid === this.trustedTeam.oid) {
      this.notificationService.warning(`A service cannot trust itself.`);
      return;
    }

    try {
      const newTrustedService: NewTrustedService = {
        ServiceTreeId: this.team.oid,
        TrustedServiceTreeId: this.trustedTeam.oid,
      };
      const result = await this.options.save(newTrustedService);
      this.activeModal.close(result);
    } catch (e) {
      this.notificationService.error(e);
    }
  }

  get isSelfTrust(): boolean {
    return !!this.team && !!this.trustedTeam && this.team.oid === this.trustedTeam.oid;
  }
}
